module.exports = __webpack_public_path__ + "img/faq-grid-03.7f6daf73.png";